import { render } from "./MorphingInfinity.vue?vue&type=template&id=3a1cc165&scoped=true"
import script from "./MorphingInfinity.vue?vue&type=script&lang=js"
export * from "./MorphingInfinity.vue?vue&type=script&lang=js"

import "./MorphingInfinity.vue?vue&type=style&index=0&id=3a1cc165&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a1cc165"]])

export default __exports__